import { render, staticRenderFns } from "./HistorialLista.vue?vue&type=template&id=3898e60c&scoped=true"
import script from "./HistorialLista.vue?vue&type=script&lang=js"
export * from "./HistorialLista.vue?vue&type=script&lang=js"
import style0 from "./HistorialLista.vue?vue&type=style&index=0&id=3898e60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3898e60c",
  null
  
)

export default component.exports